/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Conditional,
  Text,
  Space,
  Icon,
} from '@cashfree-intl/coherent';
import { copyToClipboard } from 'utils/common';
import CustomIcon from 'components/CustomIcons';
import { Action } from 'styles';
import {
  StyledCopyToClipboard,
  StyledDetailsContainer,
  StyledDetailsObject,
  StyledDisplayText,
  StyledPaper,
} from '../styled';
import {
  BANK_VALIDATION_FAILED,
  DETAILS_DISPLAY_TEXT_MAPPING,
} from '../constants';

function VendorBankDetails({
  vendorDeleted,
  bankDetailsObj,
  vendorId,
  onEditClickHandler,
}) {
  return (
    <StyledPaper>
      <Space direction="column">
        <Space justifyContent="space-between" alignItems="center">
          <Space alignItems="center" gap={1} className="mb-4">
            <Text variant="h16" strong>
              Bank Details
            </Text>
            <Conditional if={bankDetailsObj?.status === BANK_VALIDATION_FAILED}>
              <Icon name="PENDING" fill="#CB2C2C" />
            </Conditional>
          </Space>
          <Conditional if={!vendorDeleted}>
            <Button
              secondary
              size="small"
              onClick={() => onEditClickHandler('bankDetails')}
              data-event-name="Form_VendorBankDetails_Button_Edit"
            >
              <CustomIcon componentName="EDIT" className="mr-1" />
              Edit
            </Button>
          </Conditional>
        </Space>
        <StyledDetailsContainer>
          {Object.keys(bankDetailsObj).map(obj => (
            <Conditional if={obj !== 'status'}>
              <StyledDetailsObject key={obj} gap={5} className="mb-2">
                <StyledDisplayText variant="b14" color="bodyLight">
                  {DETAILS_DISPLAY_TEXT_MAPPING[obj]}
                </StyledDisplayText>
                <Space gap={1} alignItems="center">
                  <Text
                    variant="b14"
                    color={obj === 'remarks' ? 'warning' : 'bodyLight'}
                  >
                    {bankDetailsObj[obj]}
                  </Text>
                  {obj === 'accountHolder' && (
                    <StyledCopyToClipboard>
                      <Action>
                        <CustomIcon
                          componentName="COPY_TO_CLIPBOARD"
                          handleClick={copyToClipboard(vendorId)}
                        />
                      </Action>
                    </StyledCopyToClipboard>
                  )}
                </Space>
              </StyledDetailsObject>
            </Conditional>
          ))}
        </StyledDetailsContainer>
      </Space>
    </StyledPaper>
  );
}

VendorBankDetails.propTypes = {
  vendorDeleted: PropTypes.bool.isRequired,
  bankDetailsObj: PropTypes.object.isRequired,
  vendorId: PropTypes.string.isRequired,
  onEditClickHandler: PropTypes.func.isRequired,
};

export default VendorBankDetails;
